export default {

    impacts: 'Impactos',
    impactFactors: 'Factores de Impacto',
    impactFactor: 'Factor de impacto',
    impactMeasures: 'Niveles de Impacto',
    saveMeasures: 'Guardar Medidas',
    addImpactFactor: 'Agregar Factor de Impacto',
    savingImpactMeasures: 'Guardando Medidas de Impacto',
    impactMeasuresSavedSuccessfully: 'Medidas de impacto guardadas correctamente',
    loadingImpactMeasures: 'Cargando medidas de impacto...',
    savingImpactFactor: 'Guardando factor de impacto',
    theImpactFactor: 'el factor de impacto!',
    errorDeletingImpactFactor: 'Ha ocurrido un error al eliminar el factor de impacto!',
    impactFactorDeletedSuccessfully: 'Factor de impacto eliminado correctamente!',
    impact: 'Impacto',
    impactLevel: 'Nivel de impacto',
    noImpactFactor: 'No existe el factor de impacto',
    noImpactFactors: 'No hay factores de impacto',
    whatIsImpactFactor: '¿Qué es un factor de impacto?',
    impactDefinition: 'representa el nivel de afectación en los activos de tu organización.',
    impactGuide: 'que permiten cuantificar su alcance. Para facilitar tu análisis, hemos preparado algunos factores de impacto predeterminados. Puedes habilitarlos para tu organización o agregar nuevos para tu empresa.',
    measuredBy: 'Se mide a través de',
    goToImpactSection: 'Ir a la sección de impactos',

};
